import {
  Suspense,
  LazyExoticComponent,
  ReactElement,
  FunctionComponent,
} from 'react'
import Loader from '../Loader'

const Loadable =
  (Component: LazyExoticComponent<FunctionComponent>) =>
  // eslint-disable-next-line react/display-name
  (): ReactElement =>
    (
      <Suspense fallback={<Loader />}>
        <Component />
      </Suspense>
    )

export default Loadable
